/**
 * Creates and configures the video element for the Dash player.
 * Sets necessary attributes and styles for the video element.
 * @param {HTMLElement} mediaSection - The media section element where the video element will be appended.
 * @param {HTMLElement} videoUrl - The url of the video to play
 * @returns {HTMLVideoElement} - The configured video element.
 */
export function setupVideoElement(mediaSection, videoUrl) {
  const videoElement = document.createElement('video');
  videoElement.setAttribute('id', 'videoPlayer');
  videoElement.setAttribute('muted', 'false');
  videoElement.setAttribute('playsinline', 'true');
  videoElement.setAttribute('webkit-playsinline', 'true');
  if (videoUrl) {
    videoElement.setAttribute('src', videoUrl);
  }

  Object.assign(videoElement.style, {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center center',
    zIndex: '10',
    display: 'none',
  });

  mediaSection.appendChild(videoElement);
  return videoElement;
}
